export const SectionHeading = ({ eyebrow, title, subtitle, dark = false, align = "center" }) => (
  <div className={`mb-14 ${align === "center" ? "text-center mx-auto max-w-3xl" : ""}`} data-testid="section-heading">
    {eyebrow && <p className="text-stranger-orange text-xs font-bold tracking-[0.25em] uppercase mb-3">{eyebrow}</p>}
    <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight ${dark ? "text-clean-white" : "text-midnight-black"}`}>{title}</h2>
    {subtitle && <p className={`mt-4 text-base sm:text-lg font-medium ${dark ? "text-clean-white/70" : "text-midnight-black/70"}`}>{subtitle}</p>}
  </div>
);
